var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconQuestionMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14ZM7.22122 5.87574C7.6414 5.50809 8.35888 5.50809 8.77905 5.87574C9.1405 6.19201 9.1405 6.65799 8.77905 6.97426C8.70945 7.03516 8.63059 7.08699 8.54408 7.12886C8.02725 7.37898 7.25014 7.95234 7.25014 8.9V9.35C7.25014 9.76421 7.58592 10.1 8.00014 10.1C8.41435 10.1 8.75014 9.76421 8.75014 9.35V8.9C8.75014 8.878 8.75673 8.8268 8.83208 8.74071C8.9112 8.6503 9.03899 8.55577 9.19752 8.47905C9.39942 8.38134 9.59171 8.25633 9.76681 8.10313C10.8112 7.18924 10.8112 5.66076 9.76681 4.74687C8.78109 3.88438 7.21918 3.88438 6.23347 4.74687C5.92174 5.01964 5.89015 5.49346 6.16291 5.80519C6.43567 6.11691 6.90949 6.1485 7.22122 5.87574ZM8 10.4C7.58579 10.4 7.25 10.7358 7.25 11.15V11.1545C7.25 11.5687 7.58579 11.9045 8 11.9045H8.0045C8.41871 11.9045 8.7545 11.5687 8.7545 11.1545V11.15C8.7545 10.7358 8.41871 10.4 8.0045 10.4H8Z",
    fill: "#60636B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestionMark);
export default __webpack_public_path__ + "static/media/icon-question-mark.e30207eed78f0f7796b0fcbe993413a2.svg";
export { ForwardRef as ReactComponent };